import { Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Component, EventEmitter, Output } from '@angular/core';
import { Table } from 'primeng/table';
import { ListBase } from 'src/app/components/core/_infrastructure/classes/listBase';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { FilterSearchingBaseViewModel } from 'src/app/components/core/_infrastructure/types/common';
import { proxiedPropertiesOf } from 'src/app/components/core/_infrastructure/types/utils';
import { PuntoInspeccionItemResultsViewModel, PuntoInspeccionItemViewModel } from '../puntoinspeccion.types';

@Component({
    selector: 'app-puntoinspeccion-list',
    templateUrl: './puntoinspeccion-list.component.html',
})
export class PuntoInspeccionListComponent extends ListBase implements OnInit, OnChanges {
    @Input() result: PuntoInspeccionItemResultsViewModel;
    @Input() lastFilter: FilterSearchingBaseViewModel;

    @Output() search = new EventEmitter<FilterSearchingBaseViewModel>();
    @Output() edit = new EventEmitter<number | null>();
    @Output() delete = new EventEmitter<number>();

    @ViewChild('tableSearch') turboTable: Table;

    cols: any[];

    titleList = 'Listado de Puntos de  Inspección';

    constructor(protected notificationService: NotificationService) {
        super(notificationService);
    }

    ngOnInit(): void {
        this.initCols();
        this.loading = false;
        if (this.turboTable) {
            this.turboTable.first = 0;
        }
    }

    private initCols(): void {
        const model = proxiedPropertiesOf<PuntoInspeccionItemViewModel>();

        this.cols = [
            { field: 'Link', header: '' },
            { field: model.Id, header: 'Id', display: 'none' },
            { field: model.Codigo, header: 'Código' },
            { field: model.IdTipoPuntoInspeccionDescripcion, header: 'Tipo' },
            { field: model.Descripcion, header: 'Descripción' },
            { field: model.IdPaisDescripcion, header: 'País' },
            { field: model.IdProvinciaDescripcion, header: 'Provincia' },
            { field: model.IdMunicipioDescripcion, header: 'Municipio' },
            { field: model.Localidad, header: 'Localidad' },
            { field: model.CodigoPostal, header: 'Código postal' },
            { field: model.Email, header: 'Email' },
            { field: model.CodigoTraces, header: 'Código Traces' },
            { field: model.Activo, header: 'Activo' },
            {
                field: model.HabilitadoParaImportacion,
                header: 'Habilitado para importación',
            },
            {
                field: model.HabilitadoParaExportacion,
                header: 'Habilitado para exportación',
            },
            {
                field: model.HabilitadoSanidadExterior,
                header: 'Habilitado para Higiene',
            },
            {
                field: model.ReasignableEx,
                header: 'Reasignable',
            },
            {
                field: model.FinesDeSemana,
                header: 'Fines De Semana',
            },
            //{
            //    field: model.NumeroInspectores,
            //    header: "Número de Inspectores",
            //},
        ];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.result?.currentValue) {
            this.result = { ...changes.result.currentValue };
            this.loading = false;
            setTimeout(() => {
                if (this.turboTable) {
                    this.turboTable.sortOrder = this.lastFilter?.Asc;
                    this.turboTable.sortField = this.lastFilter?.OrderBy;
                    this.turboTable.first = this.lastFilter.PageNumber * this.result.PageSize; // i.e. página 4 * 15 elementos x página
                }
            }, 100);
        }
    }

    onSearchLazy(event: any): void {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        const pageNumber = event.first / event.rows;
        this.loading = true;

        const f: FilterSearchingBaseViewModel = {
            PageNumber: pageNumber,
            Asc: event.sortOrder,
            OrderBy: event.sortField,
        };

        this.search.emit(f);
    }

    onEdit(item: PuntoInspeccionItemViewModel): void {
        this.edit.emit(item?.Id);
    }

    onDelete(item: PuntoInspeccionItemViewModel): void {
        this.delete.emit(item?.Id);
    }
}
